import { RestService } from "./RestService";

export class CachingService extends RestService {
  constructor() {
    super("/api/v1/caching");
  }

  async invalidateAll() {
    return await this.postImpl("groups/invalidate", {});
  }
  
  async invalidate(key) {
    return await this.postImpl(`groups/invalidate/${key}`, {});
  }

  async fetchGroups() {
    return await this.getImpl("groups");
  }
}
